import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseUserIntegration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventIntegrationConnected = () => {
  const { websocket, integrationsStore } = useEntitiesContext()
  const handler = (data: IResponseUserIntegration) => {
    integrationsStore.syncUserIntegration(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationConnected, handler), [])
}
